import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./contact.scss"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEnvelope, faPhone, faMessage } from '@fortawesome/free-solid-svg-icons';
import emailjs from '@emailjs/browser';

const Contact = React.forwardRef((props, ref) => {

  const [disable,setDisable] = useState(false);

  const [formData, setFormData] = useState({
    username: '',
    email: '',
    phone: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    setDisable(true);
    e.preventDefault();
    const serviceID = 'service_8vlgs4g';
    const templateID = 'template_hzsxv4c';
    const publicKey = 'LmC9uLg-4IzNKKZuz';

    emailjs
      .send(serviceID, templateID, formData, publicKey)
      .then((response) => {
        console.log('SUCCESS!', response.status, response.text);
        toast.success('Email sent successfully!');
        setDisable(false);
        setFormData({ username: '', email: '', phone: '', message: '' }); // Clear the form
      })
      .catch((error) => {
        console.error('FAILED...', error);
        toast.error('Failed to send email. Please try again.');
      });
  }

  return (
    <div ref={ref} className="contact-container">
      <div className="contact-container__heading">
        <span>Contact Us</span>
      </div>
      <div className="input-field-img-container">
        <form onSubmit={handleSubmit} className="input-field-img-container__inputs">
          <div className="input-field-img-container__sub-container">
            <FontAwesomeIcon icon={faUser}
              className="input-field-img-container__sub-container__icon" />
            <input type="text"
              placeholder="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              className="input-field-img-container__sub-container__info" />
          </div>
          <div className="input-field-img-container__sub-container">
            <FontAwesomeIcon icon={faEnvelope} className="input-field-img-container__sub-container__icon" />
            <input type="text"
              placeholder=" mail id"
              name='email'
              value={formData.email}
              onChange={handleChange}
              required
              className="input-field-img-container__sub-container__info" />
          </div>
          <div className="input-field-img-container__sub-container">
            <FontAwesomeIcon icon={faPhone}
              className="input-field-img-container__sub-container__icon" />
            <input type="text"
              placeholder="phone number"
              name='phone'
              value={formData.phone}
              onChange={handleChange}
              required
              className="input-field-img-container__sub-container__info" />
          </div>
          <div className="input-field-img-container__sub-container">
            <FontAwesomeIcon icon={faMessage}
              className="input-field-img-container__sub-container__icon" />
            <input type="text"
              placeholder="message"
              name='message'
              value={formData.message}
              onChange={handleChange}
              required
              className="input-field-img-container__sub-container__info" />
          </div>
          <div className="input-field-img-container__sub-container__button-container">
            <button className="input-field-img-container__sub-container__button-container__button" disabled={disable}>Send Message</button>
          </div>
        </form>
        <div >
          <img alt="contact" className="input-field-img-container__img" src="/contact-images/contact-img.jpg"></img>
        </div>
      </div>
      <ToastContainer />
    </div>
  )
});

export default Contact;